<div class="spen-mod-paginate">
  <span>
    @if (cannotMoveToPrev) {
      <i class="fa fa-chevron-left"></i>
    } @else {
      <a (click)="!!pageMoveTo(-1)">
        <i class="fa fa-chevron-left"></i>
      </a>
    }
  </span>

  @if (!displayFirst) {
    <ng-container *ngTemplateOutlet="button; context: { page: 1 }"></ng-container>
  }

  @if (visibleLeftGap) {
    <span class="gap">･･･</span>
  }

  @for (page of activePages; track page) {
    <ng-container *ngTemplateOutlet="button; context: { page: page }"></ng-container>
  }

  @if (visibleRightGap) {
    <span class="gap">･･･</span>
  }

  @if (!displayLast) {
    <ng-container *ngTemplateOutlet="button; context: { page: lastPage }"></ng-container>
  }

  <span class="last">
    @if (cannotMoveToNext) {
      <i class="fa fa-chevron-right"></i>
    } @else {
      <a (click)="!!pageMoveTo(1)">
        <i class="fa fa-chevron-right"></i>
      </a>
    }
  </span>
</div>

<ng-template #button let-page="page">
  @if (page === currentPage) {
    <span class="current">{{ page }}</span>
  } @else {
    <span
      ><a (click)="!!currentPageChange.emit(page)">{{ page }}</a></span
    >
  }
</ng-template>
